var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNewLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 32,
    viewBox: "0 0 104 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4238 29.4354V2.87891H44.4241V29.4354H36.4238Z",
    fill: "#1C4C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6842 15.8238C74.6842 18.5153 74.1162 20.8981 72.9808 22.9722C71.8572 25.034 70.2457 26.6267 68.1469 27.7502C66.0481 28.8737 63.6284 29.4354 60.8877 29.4354H49.6465V2.87891H60.6468C70.0054 2.87891 74.6842 7.19387 74.6842 15.8238ZM66.1842 15.8979C66.1842 14.6015 65.9187 13.4349 65.3877 12.3978C64.8691 11.3607 64.1224 10.5582 63.1467 9.99029C62.1715 9.42233 61.0232 9.1384 59.7024 9.1384H57.6468V23.176H59.8873C61.8012 23.176 63.3259 22.5216 64.4618 21.2129C65.6101 19.8919 66.1842 18.1202 66.1842 15.8979Z",
    fill: "#1C4C5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9822 29.4354L87.6113 16.6201C86.8708 15.6078 86.2653 14.6941 85.7965 13.8793H85.7225C85.7965 15.188 85.8335 16.6572 85.8335 18.2869V29.4354H78.4258V2.87891H85.9818L94.9635 15.0645C95.0744 15.225 95.2105 15.4164 95.3707 15.6386C95.5315 15.8609 95.6917 16.0892 95.8524 16.3238C96.0127 16.5584 96.1611 16.7868 96.2966 17.009C96.445 17.2313 96.556 17.4288 96.6299 17.6016H96.7044C96.6299 17.0584 96.5929 16.1201 96.5929 14.7867V2.87891H104.001V29.4354H96.9822Z",
    fill: "#1C4C5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67383 0H30.5396V23.8658H6.67383V0ZM7.38496 0.711138V23.1546H29.8284V0.711138H7.38496Z",
    fill: "#1C4C5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3418 3.75391H27.2076V27.6197H3.3418V3.75391ZM4.05293 4.46505V26.9085H26.4964V4.46505H4.05293Z",
    fill: "#1C4C5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.50586H23.8657V31.3716H0V7.50586ZM0.711136 8.217V30.6605H23.1546V8.217H0.711136Z",
    fill: "#1C4C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNewLanding);
export default __webpack_public_path__ + "static/media/logo-new-landing.b6b3dc2c.svg";
export { ForwardRef as ReactComponent };